// src/source/productsList.js
import product1 from "../assets/Image4.avif";
import product2 from "../assets/image3.webp";
import product3 from "../assets/images2.png";
import product4 from "../assets/Image5.jpg";
import product5 from "../assets/images6.jpeg";
import product6 from "../assets/Images7.jpeg";

export const ProductsList = [
  {
    id: "ccna",
    image: product3,
    name: "Cisco Certified Network Associate (CCNA)",
    desc: "Product, technology, and certification training, developed by IT experts for individuals and teams",
    details: `Whether you’re learning the fundamentals with CCNA or upskilling your team, Cisco can help you accelerate your career, sharpen your skills, or give your business a competitive edge.

With multiple training formats available — including e-learning, instructor-led, and now digital subscriptions from Cisco U. — you can learn anywhere, anytime, and at your own pace.

No matter what you choose to study, and how you choose to do it, training with Cisco means staying in sync with tech innovations as your career evolves.

For a complete view of our training, Click Here`,
  },
  {
    id: "mos",
    image: product2,
    name: "Microsoft Office Specialist (MOS)",
    desc: "Boost Your Employability, Increase Productivity, Enhance Communication, Lifelong Learning Tool",
    details: `The entire Microsoft Office course is designed under expert supervision to equip our students with both theoretical core concepts and practical skills.

Whether you are a beginner or a professional looking for skill enhancement, this MS Office course fulfills your needs.

This certification covers Word, Excel, PowerPoint, and Outlook to empower you in business and personal productivity.

For a complete view of our training, Click Here`,
  },
  {
    id: "aws",
    image: product1,
    name: "Amazon Web Services (AWS) Cloud",
    desc: "Cloud Architecture and Design, Deep understanding of Amazon S3, Database Management, Serverless Computing",
    details: `Cloud technologies power nearly every modern application you use-including this website.

AWS dominates the cloud market, with over 38,000 job openings in India alone, as per LinkedIn.

Master AWS architectural principles and services like EC2, S3, Load Balancing and VPC for scalable

cloud solutions.

Achieve expertise in efficient cloud deployments by optimising the architecture and reducing cost.

Enhance your skills in implementing AWS security measures and abiding by the compliance standards

Introduction to Cloud Computing and Amazon Web Services, Load Balancing, Autoscaling, and Domain Name

Servers Networking in AWS and Isolated Virtual Private Cloud, Exploring the Storage Service on AWS, Getting

Started with Database Services

For a complete view of our training, Click Here`,
  },
  {
    id: "python",
    image: product4,
    name: "Python Programming & Automation",
    desc: "Web Scraping, File Management, Data Processing. GUI Automation, Email Automation",
    details: ` Python programming is widely used for automation due to its simplicity, readability, and extensive libraries. It allows users to automate a wide array of tasks, from simple repetitive Python automation involves creating scripts or programs that execute tasks automatically, minimizing or eliminating the need for manual intervention. This can range from basic tasks like file management and data manipulation to more complex operations such as web scraping, interacting with APIs, and even controlling graphical user interfaces (GUIs)processes to complex workflows, saving time and effort in various domains. Python automation is a good career choice due to the increasing demand for automation across various industries, such as Business, Software Development, Data Analysis, Web Development, System Administration, and Everyday Tasks.

  For a complete view of our training, Click Here`,
  },
  {
    id: "java",
    image: product5,
    name: "Java Programming",
    desc: "Enterprise Applications, Android Development, Web Applications, Big Data Technologies, Scientific Applications",
    details: `Java is a high-level, class-based, object-oriented programming language designed to have as few implementation

dependencies as possible. It is a general-purpose programming language intended to let programmers write once,

run anywhere (WORA), meaning that compiled Java code can run on all platforms that support Java without the need

to recompile.

Object-Oriented Programming (OOP):

Java is fundamentally object-oriented, incorporating concepts like encapsulation, inheritance, polymorphism, and

abstraction to structure code and manage complexity.

Platform Independence:

This is achieved through the Java Virtual Machine (JVM), which interprets compiled Java bytecode, allowing it to

execute on various operating systems and devices.

Automatic Memory Management:

Java handles memory allocation and deallocation automatically through garbage collection, reducing the risk of memory

leaks and making development easier.

Strong Community and Ecosystem:

Java boasts a large and active developer community and a vast ecosystem of libraries, frameworks (like Spring and Hibernate),

and tools that support various development needs.

For a complete view of our training, Click Here`,
  },
  {
    id: "webdev",
    image: product6,
    name: "Web Development",
    desc: "HTML and HTML5, CSS and CSS3, JavaScript, Bootstrap, React JS, Node and Express JS, Databases",
    details: `Web development courses cover a wide range of topics, from front-end technologies like HTML, CSS, and JavaScript to back-end development using languages like Python, Java, or Node.js. Full-stack courses combine both front-end and back-end knowledge.

Add interactivity to web pages with JavaScript. Describe the basics of Cascading Style Sheets(CSS3), Use the Document Object Model (DOM) to modify pages, and apply responsive design to enable the page to be viewed by various devices.

This Specialization covers the basics of how web pages are created – from writing syntactically correct HTML and CSS to adding JavaScript to create an interactive experience. While building your skills in these topics, you will create websites that work seamlessly on mobile, tablet, and large screen browsers. During the capstone, you will develop a professional-quality web portfolio demonstrating your growth as a web developer and your knowledge of accessible web design. This will include your ability to design and implement a responsive site that utilizes tools to create a site that is accessible to a wide audience, including those with visual, audial, physical, and cognitive impairments.

For a complete view of our training, Click Here`,
  },
];
